import ReactToPrint from "react-to-print";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import LayoutWithDataContainer from "../../containers/LayoutWithDataContainer";
import BannerCollapsed from "../ShopPage/components/BannerCollapsed/BannerCollapsed";
import OverlaySpiner from "../../components/OverlaySpinner/OverlaySpinner";
import { Button } from "antd";
import { useParams } from "react-router";
import {
  getPaymentByIdRequest,
  transactionPaymentActionRequest,
} from "../PaymentPage/redux/paymentActions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getPaymentById } from "../../Redux/Selectors/paymentSelector";
import { isEmpty } from "lodash";
import { getPaymentActionState } from "../PaymentPage/redux/paymentSelectors";
import { PrinterFilled } from "@ant-design/icons";
import { getTransactionByIdRequest } from "./TransactionActions";
import {
  getTransactionById,
  getTransactionIsFetching,
} from "./TransactionSelectors";
import Success from "./Status/Success";
import Failed from "./Status/Failed";
import Pending from "./Status/Pending";
import Expired from "./Status/Expired";
import usePaymentPolling from "./hooks/usePaymentPolling";
import {
  canRetryPayment,
  paymentStatus as PAYMENT_STATUS,
} from "./helpers";
import { getSupplierData } from "../../Redux/Selectors/appConfigSelector";
import {
  clickEvents,
  registerSuperProperties,
  trackEvent,
} from "../../services/mixpanel";
import { createUTCDate } from "../../helpers/tools";
import { getPaymentDataState } from "../PaymentPage/redux/paymentSelectors";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  width: 100%;
  max-width: 1150px;
  margin: 0 auto;
  padding: 20px;
  padding-bottom: 120px;
`;
const TransactionResultScreen = ({ isIframe }) => {
  const { t } = useTranslation("result");
  const { paymentId } = useParams();
  const dispatch = useDispatch();
  const detailsView = useRef();
  const supplierData = useSelector(getSupplierData);
  const paymentData = useSelector((state) => getPaymentById(state, paymentId));
  const transactionData = useSelector((state) =>
    getTransactionById(state, paymentData?.transaction)
  );
  const isFetchingTransaction = useSelector(
    getTransactionIsFetching,
    shallowEqual
  );
  const paymentDataState = useSelector(getPaymentDataState, shallowEqual);
  // Los refrescos del polling no vuelven a mostrar el spinner
  const isFetchingPaymentData = paymentDataState.fetching && !paymentData;
  const status = paymentData?.status?.toLowerCase();
  const paymentStatus = useSelector((state) =>
    getPaymentActionState(state, status)
  );
  const requestPayment = () =>
    dispatch(getPaymentByIdRequest(paymentId, supplierData._id));
  // Webpay resuelve su estado con commit/accept, así que queda fuera del polling
  const { isTimedOut } = usePaymentPolling(
    paymentData?.provider === "webpay" ? undefined : paymentData?.status,
    requestPayment
  );
  useEffect(() => {
    requestPayment();
  }, []);
  useEffect(() => {
    registerSuperProperties({
      isIframe,
    });
    trackEvent(clickEvents.OPEN_PAGE, {
      page: "TransactionResultPage",
      supplier: supplierData.name,
      supplierId: supplierData._id,
    });
  }, []);
  useEffect(() => {
    if (!isEmpty(paymentData)) {
      dispatch(getTransactionByIdRequest(paymentData.transaction));
    }
    if (
      !isEmpty(paymentData) &&
      paymentData.provider === "webpay" &&
      paymentData.data.status === "INITIALIZED"
    ) {
      dispatch(
        transactionPaymentActionRequest({
          paymentId,
          action: "commit",
        })
      );
    }
    if (
      !isEmpty(paymentData) &&
      paymentData.provider === "webpay" &&
      paymentData.data.status === "AUTHORIZED"
    ) {
      dispatch(
        transactionPaymentActionRequest({
          paymentId,
          action: "accept",
        })
      );
    }
    if (
      !isEmpty(paymentData) &&
      paymentData.provider === "webpay" &&
      paymentData.data.status === "FAILED"
    ) {
      dispatch(
        transactionPaymentActionRequest({
          paymentId,
          action: "decline",
        })
      );
    }
  }, [JSON.stringify(paymentData)]);
  if (paymentStatus?.loading && !paymentData) {
    return <OverlaySpiner isLoading={true} />;
  }
  return (
    <LayoutWithDataContainer isIframe={isIframe}>
      {!isIframe && <BannerCollapsed />}
      <Container>
        {!isFetchingTransaction && !isFetchingPaymentData ? (
          <ReactToPrint
            trigger={() => (
              <Button icon={<PrinterFilled />}>{t("print")}</Button>
            )}
            content={() => detailsView.current}
            documentTitle={transactionData?.customId}
          />
        ) : null}
        <div ref={detailsView} style={{ paddingLeft: 10, paddingRight: 10 }}>
          {paymentData?.status === "ACCEPTED" && (
            <Success
              customId={transactionData?.customId}
              buyOrder={paymentData?.data?.buy_order}
              transactionDate={
                paymentData?.data?.transaction_date
                  ? createUTCDate(paymentData.data.transaction_date).format(
                      "DD-MM-YYYY"
                    )
                  : null
              }
              authorizationCode={paymentData?.data?.authorization_code}
              installmentsNumber={paymentData?.data?.installments_number}
              cardNumber={paymentData?.data?.card_detail?.card_number}
              isLoading={isFetchingTransaction || isFetchingPaymentData}
            />
          )}
          {paymentData?.status === "DECLINED" && (
            <Failed transactionId={transactionData?._id} />
          )}
          {paymentData?.status === PAYMENT_STATUS.PENDING && (
            <Pending isTimedOut={isTimedOut} />
          )}
          {paymentData?.status === PAYMENT_STATUS.EXPIRED && (
            <Expired
              transactionId={paymentData.transaction}
              canRetry={canRetryPayment(transactionData?.status)}
            />
          )}
        </div>
      </Container>
    </LayoutWithDataContainer>
  );
};
export default TransactionResultScreen;
